// import React from "react";
// import tw from "twin.macro";
// import styled from "styled-components";

// const JobSearchContainer = tw.div`w-full flex flex-col items-center lg:items-start`;
// const JobSearchInput = tw.input`w-full p-4 mt-4 rounded bg-white border border-gray-300 focus:outline-none focus:border-primary-500`;
// const JobSearchButton = tw.button`mt-4 px-8 py-3 bg-primary-500 text-white font-bold rounded shadow transition duration-300 hocus:bg-primary-700 hocus:text-gray-100 focus:shadow-outline`;

// const JobSearchBar = () => {
//   return (
//     <JobSearchContainer>
//       <JobSearchInput type="text" placeholder="Job Title or Keywords" />
//       <JobSearchInput type="text" placeholder="Location" />
//       <JobSearchButton>Search Jobs</JobSearchButton>
//     </JobSearchContainer>
//   );
// };

// export default JobSearchBar;

import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { Server } from "App";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const JobSearchContainer = styled.div`
  ${tw`w-full flex flex-col md:flex-row items-center bg-white rounded-none md:rounded-full shadow p-2`}
`;

const JobSearchInput = styled.input`
  ${tw`w-full md:flex-1 p-4 pl-12 bg-transparent border-none focus:outline-none text-gray-600`}
`;

const LocationInput = styled.input`
  ${tw`w-full md:flex-1 p-4 bg-transparent border-t md:border-t-0 md:border-l border-gray-300 focus:outline-none text-gray-600`}
`;

const ExperienceDropdown = styled.select`
  ${tw`w-full md:flex-1 p-4 bg-transparent border-t md:border-t-0 md:border-l border-gray-300 focus:outline-none text-gray-600`}
`;

const SearchButton = styled.button`
  ${tw`w-full md:w-auto px-8 py-3 bg-blue-700 text-white font-bold rounded-full transition duration-300 hover:bg-purple-800 focus:shadow-outline`}
`;

const JobSearchIcon = styled.span`
  ${tw`absolute left-0 top-1/2 transform -translate-y-1/2 text-gray-500`}
`;

const InputWrapper = styled.div`
  ${tw`relative w-full md:flex-1`}
`;
const JobSearchBar = () => {
  const [industryData, SetIndustryData] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [city, setCity] = useState("");
  const [industry, setIndustry] = useState("");
  const naviagte = useNavigate();
  const fetchIndustries = async () => {
    try {
      const { data } = await axios.get(`${Server}/api/v1/data/industries`);
      // console.log(data.country_city);
      SetIndustryData(data.industries);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchIndustries();
    // console.log(industryData);.
  }, []);
  const search = async () => {
    try {
      let payload = {};
      if (jobTitle || city || industry) {
        if (jobTitle.length != 0) {
          payload.job = jobTitle;
        }
        if (city.length != 0) {
          payload.City = city;
        }
        if (industry.length != 0) {
          payload.Industry = industry;
        }
        // let payload = {
        //   job: jobTitle,
        //   City: city,
        //   Industry: industry,
        // };

        console.log(payload);
        naviagte("/find-jobs", { state: payload });
      } else {
        toast.error("Atleast one Field required");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <JobSearchContainer>
      <Toaster position="top-center" reverseOrder={false} />

      {/* Job Title Input with Icon */}
      <InputWrapper>
        <JobSearchIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12.9 14.32a8 8 0 111.414-1.414l5.387 5.386a1 1 0 01-1.415 1.415l-5.386-5.387zM8 14a6 6 0 100-12 6 6 0 000 12z"
              clipRule="evenodd"
            />
          </svg>
        </JobSearchIcon>
        <JobSearchInput
          type="text"
          placeholder="Search by Job Title"
          onChange={(e) => setJobTitle(e.target.value)}
        />
      </InputWrapper>

      {/* Location Input (Only Show on Desktop) */}
      <InputWrapper className="hidden md:block">
        <LocationInput
          type="text"
          placeholder="Location"
          onChange={(e) => setCity(e.target.value)}
        />
      </InputWrapper>

      {/* Industry Dropdown (Always Visible) */}
      <ExperienceDropdown onChange={(e) => setIndustry(e.target.value)}>
        <option> Select Industry</option>
        {industryData?.map((e, idx) => (
          <option key={idx} value={e}>
            {e}
          </option>
        ))}
      </ExperienceDropdown>

      {/* Search Button */}
      <SearchButton onClick={() => search()}>Search</SearchButton>
    </JobSearchContainer>
  );
};

export default JobSearchBar;


